export default __webpack_public_path__ + "static/wire2-29b6af914b4b221294ff4f65421a7df5.png";